import { Divider, Grid, Typography } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView } from "src/pages/sistema/components/FieldView";
import { dateFormatter } from "src/utils/formatters";
import { OperacionCFFields } from '../types/fields';
import { OperacionCF } from "../types/types";

type SeccionCFDatosOperacionProps = {
  operacion: OperacionCF;
}

const SeccionCFDatosOperacion = ({ operacion }: SeccionCFDatosOperacionProps) => {

  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      <Grid container spacing={2.5} rowSpacing={2.5}>
        <Grid item xs={12} md={3}>
          <FieldView label='País' value={operacion[OperacionCFFields.NombrePais]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Unidad de Negocio' value={operacion[OperacionCFFields.UnidadNegocio]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Equipo Comercial' value={operacion[OperacionCFFields.SectorComercial]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView
            label='Fecha Solicitud'
            value={operacion[OperacionCFFields.FechaSolicitud]
              ? dateFormatter.toShortDate(operacion[OperacionCFFields.FechaSolicitud])
              : '-'}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FieldView label='Razón Social de la empresa' value={operacion[OperacionCFFields.RazonSocial]} />
        </Grid>

        <Grid item xs={12} md={3}>
          <FieldView label='Prospecto o Cliente' value={operacion[OperacionCFFields.CodOperacionCFTipo] === 2 ? 'Cliente' : 'Prospecto'} />
        </Grid>

        {operacion[OperacionCFFields.CodOperacionCFTipo] === 2 && (
          <Grid item xs={12} md={3}>
            <FieldView label='Número de cuenta' value={operacion[OperacionCFFields.NumeroCuenta]} />
          </Grid>
        )}

        <Grid item xs={12}>
          <FieldView label='Información adicional de la empresa' value={operacion[OperacionCFFields.InformacionAdicionalEmpresa]} />
        </Grid>

      </Grid>
    </CardActions>
  );
}

export default SeccionCFDatosOperacion;